import React from "react"

import { connect } from "scrivito"
import { ProductPosition } from "shared/types/ProductPosition"
import { RowRendererProps } from "shared/ui/table/types"

import { ProductPositionTableProductPositionRow } from "./ProductPositionTableProductPositionRow"
import { useProductPositionTableSharedProductPositionRowModel } from "./hooks/useProductPositionTableSharedProductPositionRowModel"

export interface ProductPositionTableSharedProductPositionRowConnectorProps
  extends RowRendererProps<ProductPosition> {}

export function ProductPositionTableSharedProductPositionRowConnectorComponent(
  props: ProductPositionTableSharedProductPositionRowConnectorProps
) {
  return (
    <ProductPositionTableProductPositionRow
      {...useProductPositionTableSharedProductPositionRowModel(props)}
    />
  )
}
export const ProductPositionTableSharedProductPositionRowConnector = React.memo(
  connect(ProductPositionTableSharedProductPositionRowConnectorComponent)
) as typeof ProductPositionTableSharedProductPositionRowConnectorComponent
